var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    transform: "translate(-11 -12.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2789",
    "data-name": "Rectangle 2789",
    width: 8,
    height: 14,
    transform: "translate(18 12.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_10",
    "data-name": "Polygon 10",
    d: "M11,0,22,11H0Z",
    transform: "translate(33 34.5) rotate(180)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.0830b0c3d9e769c6964481289b9fd1ad.svg";
export { ForwardRef as ReactComponent };